module.exports = __webpack_public_path__ + "img/filter.8e7c84bc.svg";